<template>
  <div id="listGlCharge">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> GL Charge List</div>
          <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
          <div class="btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
              <i class="fp-export"></i> Export
            </a>
            <router-link v-if="canAddGl" class="btn btn-primary" v-bind:to="{name: 'GLChargeCreate'}"><i
              class="fp-add"> </i> Add
            </router-link>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content gl-charge-list">
            <data-table-filter-config :moduleName="'glChargeList'" ref="filterGlCharge" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process.
                batch no. is {{ batchNum }}.
                <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                             @click.native="batchProcess = 0"> Click Here
                </router-link>
                to check file status!
              </p>
              <section class="data-table bg-white">
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'glChargeList'" :position="'top'">
                </custom-pagination>

                <vue-good-table
                  ref="listGLChargeTable"
                  mode="remote"
                  title="GLCharge"
                  @on-page-change="onPageChange"
                  @on-selected-rows-change="selectionChanged"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-sort-change="onSortChange"
                  @on-select-all="onSelectAll"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                  :select-options="{
                                      enabled: gl_charge_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                  :search-options="{
                                      enabled: false,
                                      }">

                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                    <div :key="key">
                      <div v-if="props.column.field == 'action'">
                        <router-link v-if="canUpdateGl" title="Edit GLCharge" class="fp-edit"
                                     v-bind:to="{name: 'GLChargeEdit',params:{id:props.row.id}}"></router-link>
                      </div>
                      <div v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </div>
                    </div>
                  </template>
                  <div slot="selected-row-actions">
                    <button v-if="gl_charge_value" id="deleteGLChargeBtn" v-on:click.prevent="glChargeDelete"
                            class="btn btn-danger">Delete
                    </button>
                  </div>
                </vue-good-table>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from 'vue';
import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import {contractMixins} from '../../mixins/contractMixins';

export default {
  name: "GLChargeList",
  metaInfo: {
    title: "GL Charge List | " +process.env.COPYRIGHT_NAME
  },
  mixins: [contractMixins, commonMixins, dataTableMixins],
  data: () => ({
    userColumns: [],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
      },
      {
        label: 'Charge Identifier',
        field: 'charge_identifier',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Charge Identifier", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Name',
        field: 'charge_name',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Name", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Type',
        field: 'cntrc_type',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Type", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Location Code',
        field: 'location_code',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Location Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Contract Type Code',
        field: 'contract_type_code',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Contract Type Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'GL Code',
        field: 'gl_code',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "GL Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Vehicle Type Code',
        field: 'vehicle_type_code',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Vehicle Type Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Vehicle Pool Code',
        field: 'vehicle_pool_code',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Vehicle Pool Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Updated By',
        field: 'updated_by',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Updated By", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Updated At',
        field: 'updated_at',
        filterable: true,
        fpFieldType: "date",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    accountTypesArr: [],
    totalRecords: 0,
    permissions: [],
    loading: false,
    action: "list",
    cantAccessPage: "",
    gl_charge_value: false,
    canAddGl: false,
    canUpdateGl: false,
    assetActive: 'active',
    equityActive: '',
    liabilitiesActive: '',
    revenueActive: '',
    suspenseActive: '',
    expenseActive: '',
    pageKey: "_gl_charge_list_",
    firstLoad: 0,
    batchProcess: 0,
    batchNum: "",
    filterAll: [],
  }),
  watch: {

    permissions: function (permission) {
      var self = this;
      permission.forEach(function (permissions) {
        if (permissions.name == 'list_gl_account') {
          self.cantAccessPage = true;
        }
        if (permissions.name == 'delete_gl_account') {
          self.gl_charge_value = true;
        }
        if (permissions.name == 'add_gl_account') {
          self.canAddGl = true;
          self.canUpdateGl = true;
        }
      });
    },
  },
  created: function () {
    var self = this;
  },
  mounted: function () {
    this.getPermissions();
    this.loadFieldData(['chargeTypes']);
  },
  methods: {
    cancelAll: function () {
      this.$refs.listGLChargeTable.unselectAllInternal();
    },

    selectionChanged(param) {
      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      var rowData = self.$refs['listGLChargeTable'].selectedRows;
      console.log(rowData);
    },

    exportCheck: function () {
      var self = this;
      var count = 0;
      var actionFlag = "";
      var data = this.$refs['listGLChargeTable'].selectedRows;
      count = data.length;

      if(this.serverParams.selectedAll == true){
          actionFlag = "";
      }else if(count != 0 && count <= 100){
          actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },

    loadList() {
      var self = this;
      self.loading = true;
      var data = this.$refs['listGLChargeTable'].selectedRows;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        use.push(this.$refs['listGLChargeTable'].selectedRows[i].id)
      }

      self.filterAll = self.serverParams.columnFilters;
      if (self.action == "export") {
        self.filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }

      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.filterAll,
        sort: self.serverParams.sort,
        action: self.action,
        all: self.serverParams.selectedAll,
        id: use,
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/charge-account/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          console.log("dataaaaaaaaa", data)
          self.loading = false;
          if (data.status == "success") {
            if (self.action == 'delete') {
              self.action = "list";
              self.$refs.filterGlCharge.clearSelectAll();
              self.$swal('', 'GL charge have been deleted successfully', 'success');
              EventBus.$emit('clear-all-flags', false);
              self.loadList();

            } else {
              if (self.action == "export" || self.action == "export_queue") {
                if (data.code == "201") {
                  alert(data.message);
                } else {
                  if (self.action == "export") {
                    self.excel = data.content.web;
                    var save = document.createElement("a");
                    save.href = self.excel;
                    save.download = data.content.web;
                    save.target = "_blank";

                    document.body.appendChild(save);
                    save.click();
                    document.body.removeChild(save);
                  } else {
                    self.batchProcess = 1;
                    self.batchNum = data.content;
                  }
                }
                self.action = "list";
                self.loadList();
              } else {
                self.rows = data.content.row;
                self.totalRecords = data.content.totalRecords;
                self.filteredFlag = false;
              }
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (self.action == 'export') {
            self.generateStatusCodeMessage(jqXHR, true, 'glaccount-export');
          } else {
            self.generateStatusCodeMessage(jqXHR, false, 'glaccount-list');
          }
        }
      });
    },
    glChargeDelete() {
      var self = this;
      self.$swal({
        title: 'Are you sure that you want to delete this GL Charge?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          self.action = 'delete';
          self.loadList();
        } else {
          console.log("no");
        }
      });
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/accounting/GlChargeList.vue